import React, { useState, useEffect } from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableHead, TableRow, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PaginationComponent from '../Pagination';
import { getRoles } from '../../api';

const RoleList = () => {
    const navigate = useNavigate();
    const [roles, setRoles] = useState([]);
    const [page, setPage] = useState(1);
 //   const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
        const fetchRoles = async () => {
            try {
                const response = await getRoles({ page });
                setRoles(response.data);
               // setTotalPages(response.data.totalPages);
            } catch (error) {
                console.error('Error fetching roles:', error);
            }
        };
        fetchRoles();
    }, [page]);

    return (
        <Box p={3}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h5">Role List</Typography>
                <Button variant="contained" color="primary" onClick={() => navigate('/add-role')}>
                    Add Role
                </Button>
            </Box>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Role Name</TableCell>
                        <TableCell>Permissions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {roles.map((role) => (
                        <TableRow key={role._id}>
                            <TableCell>{role.name}</TableCell>
                            <TableCell>{role.permissions.join(', ')}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Box>
    );
};

export default RoleList;
